import { useDroppable } from "@dnd-kit/core";
import { GridRow, GridRowProps } from "@mui/x-data-grid/components/GridRow";
import React from "react";

import {
    TRACKING_TASK_DROP_PREFIX,
    useTrackingDndOverTaskId,
    useTrackingDndOverTaskIsValid,
} from "@/stores/use-tracking-dnd";

const TrackingDroppableTaskRow = React.forwardRef<HTMLDivElement, GridRowProps>(
    function TrackingDroppableTaskRow(props, outerRef) {
        const taskId = String(props.row?.id ?? "");
        const isArrival = Boolean(props.row?.isArrival);

        const { setNodeRef } = useDroppable({
            id: `${TRACKING_TASK_DROP_PREFIX}${taskId}`,
            data: { taskId, isArrival },
        });

        const overTaskId = useTrackingDndOverTaskId();
        const isOver = overTaskId === taskId;
        const isValid = useTrackingDndOverTaskIsValid();
        const highlightInvalid = isOver && isValid === false;
        const highlightValid = isOver && isValid !== false;

        const mergedRef = (el: HTMLDivElement | null) => {
            setNodeRef(el);
            if (typeof outerRef === "function") outerRef(el);
            else if (outerRef) (outerRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
        };

        return (
            <GridRow
                ref={mergedRef}
                {...props}
                style={{
                    ...props.style,
                    backgroundColor: highlightInvalid
                        ? "rgba(239,68,68,0.07)"
                        : highlightValid
                          ? "rgba(20,184,166,0.07)"
                          : undefined,
                    boxShadow: highlightInvalid
                        ? "inset 2px 0 0 0 rgba(239,68,68,0.7), inset -2px 0 0 0 rgba(239,68,68,0.7), inset 0 2px 0 0 rgba(239,68,68,0.7)"
                        : highlightValid
                          ? "inset 2px 0 0 0 rgba(20,184,166,0.7), inset -2px 0 0 0 rgba(20,184,166,0.7), inset 0 2px 0 0 rgba(20,184,166,0.7)"
                          : "none",
                    cursor: highlightInvalid ? "not-allowed" : undefined,
                    transition: "background-color 150ms ease, box-shadow 150ms ease",
                }}
            />
        );
    }
);

export default TrackingDroppableTaskRow;
